import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Switch,
  FormControlLabel,
} from "@material-ui/core";

import { useContext, useEffect, useState } from "react";

import Btn from "../../../../components/buttons/Btn";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";
import { VendedoresContext } from "../contexts/VendedoresContext";
import { v4 as uuidv4 } from "uuid";

export default function ModalVendedorInfosBancarias({
  open,
  setOpen,
  rowEdit,
  setRowEdit,
}) {
  const { bank, setBank, listBank, listOptionsPix } =
    useContext(VendedoresContext);

  const [banco, setBanco] = useState("");
  const [agencia, setAgencia] = useState("");
  const [agenciaDigito, setAgenciaDigito] = useState("");
  const [conta, setConta] = useState("");
  const [contaDigito, setContaDigito] = useState("");
  const [tipoPix, setTipoPix] = useState("");
  const [chavePix, setChavePix] = useState("");
  const [contaPrincipal, setContaPrincipal] = useState(null);

  const handleCloseModal = () => {
    setOpen(false);
    setRowEdit(null);
  };

  useEffect(() => {
    if (!rowEdit) {
      setBanco(null);
      setAgencia("");
      setAgenciaDigito("");
      setConta("");
      setContaDigito("");
      setTipoPix("");
      setChavePix(null);
      setContaPrincipal(false);
      return;
    }

    setBanco(
      listBank.find((option) => option.codigo === rowEdit.codigo_banco) || null
    );
    setAgencia(rowEdit.agencia);
    setAgenciaDigito(rowEdit.agencia_digito);
    setConta(rowEdit.conta);
    setContaDigito(rowEdit.conta_digito);
    setTipoPix(
      listOptionsPix.find((opt) => opt.label === rowEdit.tipo_pix) || null
    );
    setChavePix(rowEdit.chave_pix);
    setContaPrincipal(rowEdit.conta_padrao ? true : false);
  }, [rowEdit, listBank, listOptionsPix]);

  const handleAdd = () => {
    const body = {
      id: uuidv4(),
      codigo_banco: banco ? banco.codigo : null,
      agencia: agencia,
      agencia_digito: agenciaDigito,
      conta: conta,
      conta_digito: contaDigito,
      tipo_pix: tipoPix ? tipoPix.label : null,
      chave_pix: chavePix,
      conta_padrao: contaPrincipal,
    };

    let newArrayBank = [];
    const index = bank.findIndex((account) => account.id === rowEdit.id);

    if (rowEdit?.id) {
      body.id = rowEdit.id;
      if (rowEdit[index] !== -1) {
        const copy = [...bank];
        copy[index] = body;
        newArrayBank = copy;
      }
    } else {
      if (!bank.length) body.conta_padrao = true;
      newArrayBank = [...bank, body];
    }

    if (contaPrincipal && bank.length > 1) {
      let idPrincipal = rowEdit ? index : bank.length;
      const newList = newArrayBank.map((element, index) => {
        if ((index || index === 0) && index === idPrincipal) {
          return element;
        } else {
          return {
            ...element,
            conta_padrao: false,
          };
        }
      });
      newArrayBank = newList;
    }

    setBank(newArrayBank);

    setBanco(null);
    setAgencia("");
    setAgenciaDigito("");
    setContaDigito("");
    setConta("");
    setTipoPix(null);
    setChavePix("");
    setContaPrincipal(false);
    setOpen(false);
    setRowEdit(null);
  };

  return (
    <Dialog
      open={open}
      maxWidth="lg"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">INFORMAÇÃO FINANCEIRA</DialogTitle>

      <DialogContent>
        <Grid container spacing={2} justifyContent="flex-start">
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <SelectErp
              id="banco"
              variant="filled"
              label="Banco"
              optionsList={listBank}
              value={banco}
              setValue={setBanco}
              descriptionField="nome"
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="agencia"
              label="Agência"
              value={agencia}
              setValue={setAgencia}
            />
          </Grid>

          <Grid item lg={4} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="agenciaDigito"
              label="Dígito da Agência"
              value={agenciaDigito}
              setValue={setAgenciaDigito}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="conta"
              label="Conta"
              value={conta}
              setValue={setConta}
            />
          </Grid>

          <Grid item lg={3} md={3} sm={6} xs={12}>
            <TextFieldErp
              id="contaDigito"
              label="Dígito da Conta"
              value={contaDigito}
              setValue={setContaDigito}
            />
          </Grid>
          <Grid item lg={4} md={6} sm={6} xs={12}>
            <SelectErp
              id="tipoPix"
              variant="filled"
              label="Tipo Chave Pix"
              optionsList={listOptionsPix}
              value={tipoPix}
              setValue={setTipoPix}
              descriptionField="label"
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <TextFieldErp
              id="chavePix"
              label="Chave Pix"
              value={chavePix}
              setValue={setChavePix}
            />
          </Grid>
          <Grid item lg={3} md={6} sm={6} xs={12}>
            <FormControlLabel
              control={
                <Switch
                  checked={contaPrincipal}
                  onChange={() => setContaPrincipal((current) => !current)}
                  color="primary"
                />
              }
              label="Conta Principal"
              labelPlacement="end"
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Btn
          label="Cancelar"
          bgcolor="gray"
          textcolor="black"
          onClick={handleCloseModal}
        />
        <Btn label="Salvar" onClick={handleAdd} />
      </DialogActions>
    </Dialog>
  );
}
